/**
 * Basic TomSelect for inputting multiple strings as an array
 *
 */
import TomSelectController from "../tom_select_controller";

export default class extends TomSelectController {
  configuration(overrides = {}) {
    return super.configuration({
      plugins: ["remove_button"],
      allowEmptyOption: false,
      closeAfterSelect: true,
      create: true,
      createOnBlur: true,
      ...overrides,
    });
  }
}
